const Sdata = [
	{
		id: 1,
		title: "Free Consultation",
		desc: "	Bella Model House is perfect for people aiming to start owning a piece of a Camella community. With two bedrooms, two bathrooms, and a provision for carport, Bella has just enough space to cover your essential and favorite home basics.",
		cover: "./images/recommendedDesign/1 Bella Model House.png",
	},
	{
		id: 2,
		title: "Free Consultation",
		desc: "	Cara is Camella’s family starter house offering, with three bedrooms, two toilet-and-baths, and a provision for a single-car carport and a balcony. Start smart and surround your family with your favorite leisure activities and bring them to your beautiful first home here in Camella.",
		cover: "./images/recommendedDesign/2 Cara Model House.jpg",
	},
	{
		id: 3,
		title: "Free Consultation",
		desc: "Dani is the perfect home for our moderately-sized families. This house wastes no space and fits four bedrooms to give every single one of your children their own favorite sanctuary. Dani also has three toilet-and-baths, and a provision for a balcony and a carport within its generous area to complete its indulging package.",
		cover: "./images/recommendedDesign/3 Dani Model House.png",
	},
	{
		id: 4,
		title: "Free Consultation",
		desc: "Ella does something different with its space. It has a big bedroom next to a bath and toilet on the house’s ground floor, making mobility for engaging in favorite pastimes easy for the elder members of your family. This also frees up more area for the bedrooms upstairs for a total of five rooms. This home gets even more inventive by allocating a provision for a carport and a balcony to complete the grand package. Ella is a perfect home option for bigger families with elderly.",
		cover: "./images/recommendedDesign/4 Ella Model House.jpg",
	},
	{
		id: 5,
		title: "Free Consultation",
		desc: "Freya stands out for its flexible hobby room that you could transform into an office area, a passion corner, or a gallery for your favorite collectibles. This is on top of its five spacious bedrooms, three large toilet-and-baths, and a provision for a carport and a balcony. With all these inclusions, Freya has more than enough space for your expanding family.",
		cover: "./images/recommendedDesign/5 Freya Model House.jpg",
	},
	{
		id: 6,
		title: "Free Consultation",
		desc: "Greta is Camella’s most spacious house offering yet, with five spacious bedrooms, three neat toilet-and-baths, a wide two-car carport and a refreshing balcony. Its master’s bedroom is equipped with its own bathtub and a provision for a walk-in closet to give you a luxurious and better living experience. Every moment is great in Greta, where you can find your favorite features for a smart and healthy home.",
		cover: "./images/recommendedDesign/6 Greta Model House.jpg",
	},
];
export default Sdata;
